import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import { filmAPI } from '../../services/api';
import './FilmManagement.css';

const FilmManagement = () => {
  const [films, setFilms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchFilms();
  }, []);

  const fetchFilms = async () => {
    try {
      setLoading(true);
      const response = await filmAPI.getAllFilms();
      setFilms(response.data);
    } catch (err) {
      setError('Failed to load films');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this film?')) {
      try {
        await filmAPI.deleteFilm(id);
        setFilms(films.filter(film => film.id !== id));
      } catch (err) {
        alert('Failed to delete film');
      }
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading films...</p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="film-management">
        <div className="management-header">
          <h1>Film Management</h1>
          <Link to="/admin/films/upload" className="btn-add">
            Add New Film
          </Link>
        </div>
        
        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}
        
        <div className="films-table-container">
          <table className="films-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Title</th>
                <th>Description</th>
                <th>YouTube Link</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {films.length === 0 ? (
                <tr>
                  <td colSpan="5" className="empty-state">
                    No films found. <Link to="/admin/films/upload">Upload your first film</Link>
                  </td>
                </tr>
              ) : (
                films.map(film => (
                  <tr key={film.id}>
                    <td>
                      <div className="film-thumbnail">
                        <img 
                          src={film.image_url} 
                          alt={film.title}
                          onError={(e) => {
                            e.target.src = 'https://placehold.co/100x75';
                          }}
                        />
                      </div>
                    </td>
                    <td className="film-title">{film.title}</td>
                    <td className="film-description">
                      {film.description.length > 100 
                        ? `${film.description.substring(0, 100)}...` 
                        : film.description}
                    </td>
                    <td className="film-link">
                      <a 
                        href={film.youtube_link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        title={film.youtube_link}
                      >
                        Watch
                      </a>
                    </td>
                    <td className="film-actions">
                      <Link 
                        to={`/films/edit/${film.id}`}
                        className="btn-edit"
                      >
                        Edit
                      </Link>
                      <button 
                        className="btn-delete"
                        onClick={() => handleDelete(film.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        <div className="table-footer">
          <p>Total Films: {films.length}</p>
        </div>
      </div>
    </AdminLayout>
  );
};

export default FilmManagement;